<template>
    <div :class="['recipe '  + recipe.flavor]">
        <div class="container">
            <bread-crumb class="mobile"/>
            <div class="image">
                <img class="" :src="getImgUrl(recipe.image)" v-bind:alt="[recipe.flavor + ' smile']" />
            </div>
            <div class="copy">
                <bread-crumb class="desktop"></bread-crumb>
                <h1 v-html="recipe.title" ></h1>               
                <div class="ingredients">
                    <h2>ingredients</h2>
                    <ul>
                        <li v-for="(ingredient, index) in recipe.ingredients" :key="index" v-html="ingredient"></li>
                    </ul>
                </div>
                <div class="directions">
                    <h2>instructions</h2>
                    <ol>
                        <li v-for="(direction, index) in recipe.directions" :key="index" v-html="direction"></li>
                    </ol>
                    <p v-html="recipe.optional"></p>
                </div>
                <div class="alcohol-legal">
                  <p v-html="recipe.legal"></p>
                </div>
            </div>
        </div>
        <bubble-bottom-holiday v-if="recipe.flavor.includes('holiday')"> </bubble-bottom-holiday>
        <bubble-bottom v-else></bubble-bottom>
        <mix-footer />
    </div>
</template>

<script>
import BreadCrumb from "@/components/mixology/BreadCrumb";
import BubbleBottom from "@/components/mixology/BubbleBottom";
import BubbleBottomHoliday from "@/components/mixology/BubbleBottomHoliday";
import MixFooter from '@/components/mixology/MixFooter';


export default {
    name: "recipe",
    components: {
        BreadCrumb,
        BubbleBottom,
        BubbleBottomHoliday,
        MixFooter
    },
    props: {
        recipe: {
            type: Object
        }
    },
    methods: {
        getImgUrl: flavor => {
            const images = require.context(
                "./../../assets/mixology/smiles/",
                false
            );
            return  images("./" + flavor) 
        },
    },
    data() {
        return {
            recipe
        }
    }
}
</script>

<style lang="scss">
@import "./../../css-abstracts/_recipes.scss";

    .recipe {
        display:flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        min-height: calc(100vh - 270px);
        
        &[class*="holiday"] {
            background-image: url(~@/assets/mixology/holiday-recipe/snowflakes@2x.png);
            background-repeat: no-repeat;
            background-position: top right;
            background-size: 102px 95px;

            @media(min-width: 768px){
                background-size: 196px 181px;
            }
        }

        .container {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
            padding: 0 15px;
            
            @media (max-width: 768px) {
                max-width:540px;
                flex-direction:column;
                align-items: baseline;
            }

            @media (min-width: 768px) {
                flex-wrap: nowrap;
                max-width:720px;
            }

            @media (min-width: 1024px) {
                max-width:960px;
            }
            @media (min-width: 1200px) {
                max-width:1140px;
            }

            .image {

                flex: 0 0 38%;

                @media (max-width: 768px) {
                    margin-bottom: 1em;
                }
            }

            .copy {
                text-align: left;
                margin-left: 4vw;
                max-width: 400px;

                @media (max-width: 768px) {
                    margin:0;
                    
                }
            }
        }

        h1 span {
            display:inline;
        }

        h1 {
            margin: 0;
        }

        h2 {
            font-size: 16px;
            margin: 0 0 7px;
        }

        p {
            font-size: 16px;
            line-height: 1.25em;
            margin: 0;
        }

        .burst span {
            span {
                font-size: 4px;
            }
        }

        .reg {
            font-size: 33%;
            font-weight: 100;
        }
        
        .ingredients {
            padding: 2em 0 1em 0;
            
            ul {
                padding: 0 0 1em 17px;
                margin: 0;
                line-height: 1.13;
            }
        }

        .directions {
            ol {
                padding: 0 0 1em 17px;
                margin: 0;
                line-height: 1.13;
            }
        }

        .alcohol-legal p{
          margin-top: 1rem;
          font-size: 12px;
        }

        .breadcrumb {
                
                text-align:left;

                @media (min-width: 768px) {
                    &.mobile{
                        display:none;
                    }
                }

                @media (max-width: 768px) {
                    &.desktop{
                        display:none;
                    
                    }
                }

        }

        .bubble-bottom {
            margin-top: auto;
        }
        .bubble-top {
            position: absolute;
        }

    }

</style>






// WEBPACK FOOTER //
// src/components/mixology/recipe.vue